import castLessVarsToJson from 'cast-less-vars-to-json';
import { lighten } from 'polished';

const snakeToCamel = (str) =>
  str.replace(/([-][a-z])/g, (group) => group.toUpperCase().replace('-', ''));

const nameProjectionFunc = (name) => snakeToCamel(name.substr(1));

const getLessVariables = (theme) => {
  let themeVarsObj = {};
  if (theme.json) {
    // Extracting less variables object
    themeVarsObj = JSON.parse(theme.json).vars;
  }
  return themeVarsObj;
};

const evaluateLessVariables = async (themeVarsObj) => {
  if (themeVarsObj) {
    let themeVariablesString = '';
    // Forming less variables string.

    Object.entries(themeVarsObj).forEach(([key, value]) => {
      themeVariablesString += `${key}: ${value};`;
    });
    // Evaluating less variables
    return castLessVarsToJson(themeVariablesString, { nameProjectionFunc }).then((data) => {
      const VariblesData = data;
      if (
        !(
          'topbarNavActiveStateBackground' in VariblesData &&
          VariblesData.topbarNavActiveStateBackground
        )
      ) {
        VariblesData.topbarNavActiveStateBackground = lighten(
          0.35,
          VariblesData.leftNavHeaderBackground
        );
      }
      if (
        !(
          'topbarNavActiveStateTextColor' in VariblesData &&
          VariblesData.topbarNavActiveStateTextColor
        )
      ) {
        VariblesData.topbarNavActiveStateTextColor = VariblesData.leftNavParentColor;
      }
      if (
        !(
          'topbarNavHoverStateBackground' in VariblesData &&
          VariblesData.topbarNavHoverStateBackground
        )
      ) {
        VariblesData.topbarNavHoverStateBackground = lighten(
          0.15,
          VariblesData.leftNavHeaderBackground
        );
      }
      if (
        !(
          'topbarNavHoverStateTextColor' in VariblesData &&
          VariblesData.topbarNavHoverStateTextColor
        )
      ) {
        VariblesData.topbarNavHoverStateTextColor = VariblesData.leftNavParentColor;
      }
      return VariblesData;
    });
  }
  return {};
};

export { getLessVariables, evaluateLessVariables };
